export type PriorityLevel = 0 | 1 | 2 | 3;

interface IPriorityLevelEnum {
    None: PriorityLevel;
    Low: PriorityLevel;
    Medium: PriorityLevel;
    High: PriorityLevel;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 0, text: 'Netaikomas' },
    { key: 1, text: 'Žemas' },
    { key: 2, text: 'Vidutinis' },
    { key: 3, text: 'Aukštas' }
];

export const priorityLevel: IPriorityLevelEnum = {
    None: 0,
    Low: 1,
    Medium: 2,
    High: 3,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
